export default [
  {
    path: "/caibian",
    name: "",
    component: (resolve) => require(["@/views/home"], resolve),
    children: [
      {
        path: "cbIndex",
        name: "首页 ",
        meta: {
          title: "首页",
        },
        component: (resolve) =>
          require(["../views/caibian/cbIndex.vue"], resolve),
      },
      {
        path: "InvoiceQuery",
        name: "发票查询",
        meta: {
          title: "发票查询",
        },
        component: (resolve) =>
          require(["@/views/caibian/InvoiceQuery"], resolve),
      },
      {
        path: "myAuthor",
        name: "我的作者",
        meta: {
          title: "我的作者",
        },
        component: (resolve) => require(["@/views/caibian/myAuthor"], resolve),
      },
      {
        path: "manuscriptQuery",
        name: "稿件查询",
        meta: {
          title: "稿件查询",
        },
        component: (resolve) =>
          require(["@/views/caibian/manuscriptQuery"], resolve),
      },
      {
        path: "orderQuery",
        name: "订单查询",
        meta: {
          title: "订单查询",
        },
        component: (resolve) =>
          require(["@/views/caibian/orderQuery"], resolve),
      },
      {
        path: "editingAchievements",
        name: "绩效管理",
        meta: {
          title: "绩效管理",
        },
        component: (resolve) =>
          require(["@/views/caibian/editingAchievements"], resolve),
      },
      {
        path: "allManuscript",
        name: "全部稿件",
        meta: {
          title: "全部稿件",
        },
        component: (resolve) =>
          require(["../views/caibian/allManuscript.vue"], resolve),
      },
      // {
      //   path: 'auditTemplate',
      //   name: '审核模板 ',
      //   meta: {
      //     title: '审核模板'
      //   },
      //   component: resolve => require(['../views/caibian/auditTemplate.vue'], resolve),
      // },
      {
        path: "toConfirm",
        name: "录用确认",
        meta: {
          title: "录用确认",
        },
        component: (resolve) =>
          require(["../views/caibian/toConfirm.vue"], resolve),
      },
      {
        path: "UploadTerminal",
        name: "上传终稿",
        meta: {
          title: "上传终稿",
        },
        component: (resolve) =>
          require(["../views/caibian/UploadTerminal.vue"], resolve),
      },
      {
        path: "/meansCard",
        name: " ",
        meta: {
          title: "采编名片",
        },
        component: (resolve) =>
          require(["../views/caibian/meansCard.vue"], resolve),
      },
      {
        path: "articleDetail",
        name: "稿件详情 ",
        meta: {
          title: "稿件详情",
        },
        component: (resolve) =>
          require(["../views/caibian/articleDetail"], resolve),
      },
    
    ],
  },
  {
    path: "/myCard",
    name: "mayCard",
    meta: {
      title: "我的名片",
    },
    component: (resolve) => require(["../views/caibian/myCard.vue"], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/router/caibian_routers.js